import React from 'react';
import TagsManager from './TagsManager';

const TagsFilter = ({ 
  selectedTags = [], 
  onTagsChange,
  objectType,
  searchTerm = '',
  onSearchChange,
  ...props 
}) => {
  return (
    <TagsManager
      mode="filter"
      objectType={objectType}
      selectedTags={selectedTags}
      onTagsChange={onTagsChange}
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
      {...props}
    />
  );
};

export default TagsFilter;